import React from 'react'
import PropTypes from 'prop-types'
import Pen from './Pen'
import { getCurrentMonth } from '../../helpers/helpers'
import SelectProject from '../SelectProject/SelectProjectContainer'

import './ProjectHeader.css'

const HeaderTime = () => {
  const currentDay = new Date().getDate()
  const currentMonth = getCurrentMonth()
  const currentYear = new Date().getFullYear()

  return (
    <div className='header-item header-date-wrapper'>
        <div className='header-date-item header-date-day'>{currentDay}</div> 
        <div className='header-date-item'>
          <span className='header-date-month'>
            {currentMonth}
          </span>
          <span className='header-date-year'>{currentYear}</span>
        </div>
    </div>
  )
}

const ProjectHeader = ({ profile }) => (
  <header className='project-header'>
  <div className='project-header-content'>
    <div className='header-item header-title'>
      <h3 className='header-title'>
        Project
      </h3>
    </div>
    <div className='header-item'>
    <div className='header-icon-wrapper'>
      <Pen />
      <SelectProject selectedProject={profile.selectedProject} />
    </div>
      <span className='header-hourly-rate'>750:- / hour</span>
    </div>
    <HeaderTime />
    </div>
  </header>
)

ProjectHeader.propTypes = {
  profile: PropTypes.object.isRequired,
}

export default ProjectHeader



// WEBPACK FOOTER //
// ./src/components/ProjectHeader/ProjectHeader.js